import React, { useState, useEffect } from 'react';
import DashboardLayout from './DashboardLayout';
import axios from 'axios';

const DashboardProfileSettings = () => {
  const [profile, setProfile] = useState({
    name: '',
    email: '',
    profilePicture: '',
  });
  const [preview, setPreview] = useState(null);
  const [password, setPassword] = useState({ current: '', new: '', confirm: '' });
  const [loading, setLoading] = useState(false);

  // Fetch user profile on mount
  useEffect(() => {
    // Replace with your actual API endpoint
    axios.get('/api/get_profile.php')
      .then(res => setProfile(res.data))
      .catch(() => {});
  }, []);

  const handleChange = e => setProfile({ ...profile, [e.target.name]: e.target.value });

  const handlePictureChange = e => {
    const file = e.target.files[0];
    if (file) {
      setPreview(URL.createObjectURL(file));
      setProfile({ ...profile, profilePicture: file });
    }
  };

  const handleProfileUpdate = async e => {
    e.preventDefault();
    setLoading(true);
    const formData = new FormData();
    formData.append('name', profile.name);
    formData.append('email', profile.email);
    if (profile.profilePicture instanceof File) {
      formData.append('profilePicture', profile.profilePicture);
    }
    try {
      await axios.post('/api/update_profile.php', formData);
      alert('Profile updated!');
      setPreview(null);
    } catch {
      alert('Failed to update profile.');
    }
    setLoading(false);
  };

  const handlePasswordChange = async e => {
    e.preventDefault();
    if (password.new !== password.confirm) {
      alert('New passwords do not match!');
      return;
    }
    setLoading(true);
    try {
      await axios.post('/api/change_password.php', password);
      alert('Password changed!');
      setPassword({ current: '', new: '', confirm: '' });
    } catch {
      alert('Failed to change password.');
    }
    setLoading(false);
  };

  return (
    <DashboardLayout>
      <div style={{ maxWidth: 500, margin: '0 auto' }}>
        <h2>Profile Settings</h2>
        <form onSubmit={handleProfileUpdate} encType="multipart/form-data">
          <div>
            <label>Name</label>
            <input
              name="name"
              value={profile.name}
              onChange={handleChange}
              className="form-control"
              required
            />
          </div>
          <div style={{ marginTop: 10 }}>
            <label>Email</label>
            <input
              name="email"
              type="email"
              value={profile.email}
              onChange={handleChange}
              className="form-control"
              required
            />
          </div>
          <div style={{ marginTop: 10 }}>
            <label>Profile Picture</label>
            <div>
              <img
                src={preview || profile.profilePicture || '/default-avatar.png'}
                alt="Profile"
                style={{ width: 80, height: 80, borderRadius: '50%', objectFit: 'cover', marginBottom: 8 }}
              />
            </div>
            <input
              type="file"
              accept="image/*"
              onChange={handlePictureChange}
              className="form-control"
            />
          </div>
          <button type="submit" className="btn btn-primary" style={{ marginTop: 15 }} disabled={loading}>
            {loading ? 'Updating...' : 'Update Profile'}
          </button>
        </form>
        <hr />
        <form onSubmit={handlePasswordChange}>
          <h4>Change Password</h4>
          <div>
            <label>Current Password</label>
            <input
              type="password"
              value={password.current}
              onChange={e => setPassword({ ...password, current: e.target.value })}
              className="form-control"
              required
            />
          </div>
          <div style={{ marginTop: 10 }}>
            <label>New Password</label>
            <input
              type="password"
              value={password.new}
              onChange={e => setPassword({ ...password, new: e.target.value })}
              className="form-control"
              required
            />
          </div>
          <div style={{ marginTop: 10 }}>
            <label>Confirm New Password</label>
            <input
              type="password"
              value={password.confirm}
              onChange={e => setPassword({ ...password, confirm: e.target.value })}
              className="form-control"
              required
            />
          </div>
          <button type="submit" className="btn btn-secondary" style={{ marginTop: 15 }} disabled={loading}>
            {loading ? 'Changing...' : 'Change Password'}
          </button>
        </form>
      </div>
    </DashboardLayout>
  );
};

export default DashboardProfileSettings; 